import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import CreateBannerContent from 'components/banners/CreateBannerContent';
import { SaveAndBackButtons } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import { BANNER_CONTENT_TYPE, LanguageConfig } from 'config/CustomEnums';
import { BannerErrorFields } from 'models/HomeBannersModel';

import { TimeFormater, formatDate } from 'utils/TimeFormatUtil';

function CreateBannerStepOne({ banner, languages }) {
  const params = useParams();
  const dispatch = useDispatch();

  const { getValues, setValue, setError, clearErrors, watch } =
    useFormContext();

  const contentTypeField = 'contentType';
  const contentType = watch(contentTypeField);

  const getLanguageTab = (language) => {
    return [<CreateBannerContent language={language} />];
  };

  useEffect(()=> {
    if (contentType!== BANNER_CONTENT_TYPE.CAMPAIGN) {
      setValue(contentTypeField, BANNER_CONTENT_TYPE.CAMPAIGN, {
        shouldDirty: true,
      });
    }
  }, [contentType, setValue])

  useEffect(() => {
    dispatch({
      type: 'language/getList',
      payload: { isSelectorLoad: true },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const languageTabConfig = {
    containers: languages?.map((item) => ({
      container: getLanguageTab(item.code),
      key: item.code,
      title: item.sourceName,
    })),
  };

  const save = async (active) => {
    clearErrors();
    let isValid = true;

    console.log('@@53: ', getValues());
    const [
      contentType,
      campaign,
      translations,
      order,
      visiblePeriodFollowLinkedCampaign,
      visiblePeriodStartDate,
      visiblePeriodEndDate,
    ] = getValues([
      'contentType',
      'campaign',
      'translations',
      'order',
      'visiblePeriodFollowLinkedCampaign',
      'visiblePeriodStartDate',
      'visiblePeriodEndDate',
    ]);
    console.log('@83', isValid, getValues());
    if (contentType === BANNER_CONTENT_TYPE.CAMPAIGN) {
      if (campaign?.pk == null) {
        isValid = false;
        setError(
          `campaign`,
          {
            type: 'require',
            message: BannerErrorFields.campaign.message,
          },
          {
            shouldFocus: true,
          },
        );
      }
      if (!!campaign?.pk && !visiblePeriodFollowLinkedCampaign) {
        if (
          !!campaign?.displayStartDate &&
          new Date(visiblePeriodStartDate) < new Date(campaign.displayStartDate)
        ) {
          isValid = false;
          setError(
            'visiblePeriod',
            {
              type: 'require',
              message: 'The selected period must be within the linked campaign’s visible period, please try again.',
            },
            {
              shouldFocus: true,
            },
          );
          setError(
            'visiblePeriodStartDate',
            {
              type: 'require',
              message:
                'The visible period must be equal or shorter than the linked banner’s visible period, please try again.\n' +
                `The linked campaign start date: ${formatDate(
                  campaign.displayStartDate,
                  TimeFormater.dayMonthYearWeekTimePeriod,
                )}`,
            },
            {
              shouldFocus: true,
            },
          );
        }
        if (
          !!campaign?.displayEndDate &&
          new Date(visiblePeriodEndDate) > new Date(campaign.displayEndDate)
        ) {
          isValid = false;
          setError(
            'visiblePeriod',
            {
              type: 'require',
              message: 'The selected period must be within the linked campaign’s visible period, please try again.',
            },
            {
              shouldFocus: true,
            },
          );
          setError(
            'visiblePeriodEndDate',
            {
              type: 'require',
              message:
                'The visible period must be equal or shorter than the linked banner’s visible period, please try again.\n' +
                `The linked campaign end date: ${formatDate(
                  campaign.displayEndDate,
                  TimeFormater.dayMonthYearWeekTimePeriod,
                )}`,
            },
            {
              shouldFocus: true,
            },
          );
        }
      }
    }
    if (
      contentType === BANNER_CONTENT_TYPE.CAMPAIGN &&
      !!visiblePeriodFollowLinkedCampaign
    ) {
      // content type is campaign, and visiblePeriodFollowLinkedCampaign
    } else if (
      new Date(visiblePeriodStartDate) > new Date(visiblePeriodEndDate)
    ) {
      isValid = false;
      setError(
        'visiblePeriod',
        {
          type: 'require',
          message:
            'The end date & time of a banner cannot be on or before the start date and time.',
        },
        {
          shouldFocus: true,
        },
      );
    }
    let coverPhoto =
      translations?.[LanguageConfig.english]?.coverPhotos?.[0]?.value;
    if (!coverPhoto) {
      isValid = false;
      setError(
        `translations.${LanguageConfig.english}.coverPhotos.0`,
        {
          type: 'require',
          message: BannerErrorFields.bannerImage.message,
        },
        {
          shouldFocus: true,
        },
      );
    }
    let newTranslations = [];
    for (const language of languages) {
      if (language.code === LanguageConfig.english) {
        continue;
      } else {
        const data = {
          id: banner.translations?.[language.code]?.pk,
          coverPhoto: translations?.[language.code]?.coverPhotos?.[0]?.value,
          language: language.code,
        };
        newTranslations.push(data);
      }
    }
    if (order == null) {
      isValid = false;
      setError(
        `order`,
        {
          type: 'require',
          message: BannerErrorFields.order.message,
        },
        {
          shouldFocus: true,
        },
      );
    }
    let contentReferenceId = campaign?.pk;
    let uploadData = {
      ...getValues(),
      coverPhoto: coverPhoto,
      contentReferenceId: contentReferenceId,
      active: !!active,
      translations: newTranslations,
    };
    console.log('@@133: ', isValid, params.id, uploadData);
    if (isValid) {
      dispatch({
        type: 'bannerList/createOrUpdateBanner',
        payload: {
          checkStep: true,
          isCreate: params.id ? false : true,
          data: uploadData,
        },
      });
      return;
    }
  };

  return (
    <>
      <ContentSections languageTabContent={languageTabConfig} hidePreview />
      <SaveAndBackButtons
        saveTempText={'Save only'}
        saveText={`Save and ${banner.active ? 'UnPublish' : 'Publish'}`}
        saveTempAction={async () => save(banner.active)}
        saveAction={async () => save(!banner.active)}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  banner: state.bannerList.banner,
  languages: state.language.allList,
});

export default connect(mapPropsToState)(CreateBannerStepOne);
